var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatErrowLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 5,
    viewBox: "0 0 17 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.799 4.45701C16.799 1.1751 13.3685 -0.978444 10.4128 0.447932L3.94976 3.56686C2.73572 4.15273 1.4051 4.45701 0.0570916 4.45701L0.307426 4.45689C-0.385844 4.45701 0.310554 4.36597 0.307426 4.45689C0.307426 4.45689 0.178097 4.45695 0.0570916 4.45701L0.299005 4.45689C0.299005 4.45689 2.299 4.45701 2.799 4.45701C3.299 4.45701 6.799 4.45701 6.799 4.45701C7.299 4.45701 16.799 4.45701 16.799 4.45701Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatErrowLink);
export default __webpack_public_path__ + "static/media/chat-errow-link.b5a7db6f06d9f93e814529f4aa6d4a16.svg";
export { ForwardRef as ReactComponent };